import type { CSSProperties, ReactNode } from 'react';
import { useReveal } from '../../hooks/useReveal';

interface Props {
  children: ReactNode;
  /** Stagger delay in ms — useful for grids. */
  delay?: number;
  style?: CSSProperties;
}

/**
 * Scroll-triggered entrance reveal.
 * Applies `land-reveal` (opacity:0, translateY:24px) until the element
 * enters the viewport, then adds `is-visible` to transition it in.
 * prefers-reduced-motion is handled globally in index.css.
 */
export function Reveal({ children, delay = 0, style }: Props) {
  const { ref, visible } = useReveal<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`land-reveal${visible ? ' is-visible' : ''}`}
      style={delay > 0 ? { ...style, transitionDelay: `${delay}ms` } : style}
    >
      {children}
    </div>
  );
}
